import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, NgModuleRef} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EmailInvoiceMasterSheetComponent} from '../dialogs/email-invoice-master-sheet/email-invoice-master-sheet.component';
import {InvoiceService} from '../Services/invoice.service';
import {ToastrService} from 'ngx-toastr';
import {EmailAllClientInvoicesComponent} from '../dialogs/email-all-client-invoices/email-all-client-invoices.component';
import { EmailMonthlyAccountingReportComponent } from '../dialogs/email-monthly-accounting-report/email-monthly-accounting-report.component';
import { DownloadHistoricalInvoicesComponent } from '../dialogs/download-historical-invoices/download-historical-invoices.component';
import { DownloadAutopayReportComponent } from '../dialogs/download-autopay-report/download-autopay-report.component';
import { DownloadOnetimePmtReportComponent } from '../dialogs/download-onetime-pmt-report/download-onetime-pmt-report.component';
import { ReportOption } from '../models/ReportOption';
import { CourtFeesAuditReportComponent } from '../dialogs/court-fees-audit-report/court-fees-audit-report.component';
import { ResmanBillingReportComponent } from '../dialogs/resman-billing-report/resman-billing-report.component';

@Component({
  selector: 'app-invoice-home',
  templateUrl: './invoice-home.component.html',
  styleUrls: ['./invoice-home.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceHomeComponent implements OnInit {

  @ViewChild('fileUpload', {static: false}) fileUpload: ElementRef;
  public files = [];
  public selectedReportOption: ReportOption;

  constructor(
    public auth: AuthService,
    public readonly invoiceService: InvoiceService,
    private toasterService: ToastrService,
    private readonly modalService: NgbModal) {
  }

  public reportOptions: ReportOption[] = [
    { reportName: "Email Mastersheet", reportAction: 0, invokedReportModal: EmailInvoiceMasterSheetComponent, reportDownloadUrl: null },
    { reportName: "Email All Client Invoices", reportAction: 1, invokedReportModal: EmailAllClientInvoicesComponent, reportDownloadUrl: null },
    { reportName: "Download Invoicing Report", reportAction: 2, invokedReportModal: EmailMonthlyAccountingReportComponent, reportDownloadUrl: null },
    // { reportName: "Download Historical Invoices", reportAction: 3, invokedReportModal: DownloadHistoricalInvoicesComponent, reportDownloadUrl: null },
    { reportName: "Download Payments Report", reportAction: 4, invokedReportModal: DownloadAutopayReportComponent, reportDownloadUrl: null },
    // { reportName: "Download One Time Payment Report", reportAction: 5, invokedReportModal: DownloadOnetimePmtReportComponent , reportDownloadUrl: null},
    { reportName: "Download Court Fees Report", reportAction: 6, invokedReportModal: CourtFeesAuditReportComponent, reportDownloadUrl: null },
    { reportName: "Resman Billing Report", reportAction: 6, invokedReportModal: ResmanBillingReportComponent, reportDownloadUrl: null }

  ]

  public onReportSelect(): void {
    const modalRef = this.modalService.open(this.selectedReportOption.invokedReportModal, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = this.selectedReportOption.reportName;

  }

  public ngOnInit(): void {
    this.invoiceService.getInvoiceAddendumList(5);
  }
}
